var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgForward2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 19,
    height: 19,
    transform: "rotate(-180 20 24)",
    stroke: "black",
    strokeWidth: 1.60714
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6424 7.15625L35.0312 14.5781M35.0312 14.5781L27.6424 22M35.0312 14.5781L19 14.5781",
    stroke: "black",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M14.9736 20.5625H6.20215V18.8223L10.3418 14.4102C10.9102 13.7891 11.3291 13.2471 11.5986 12.7842C11.874 12.3213 12.0117 11.8818 12.0117 11.4658C12.0117 10.8975 11.8682 10.4521 11.5811 10.1299C11.2939 9.80176 10.8838 9.6377 10.3506 9.6377C9.77637 9.6377 9.32227 9.83692 8.98828 10.2354C8.66016 10.6279 8.49609 11.1465 8.49609 11.791H5.94727C5.94727 11.0117 6.13184 10.2998 6.50098 9.65527C6.87598 9.01074 7.40332 8.50684 8.08301 8.14356C8.7627 7.77442 9.5332 7.58985 10.3945 7.58985C11.7129 7.58985 12.7354 7.90625 13.4619 8.53906C14.1943 9.17188 14.5605 10.0654 14.5605 11.2197C14.5605 11.8525 14.3965 12.4971 14.0684 13.1533C13.7402 13.8096 13.1777 14.5742 12.3809 15.4473L9.47168 18.5146H14.9736V20.5625Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgForward2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Forward2.0f191cbf6cef85e7225218b61fcbb4c5.svg";